<template>
  <v-container>
    <div v-if = "$store.state.userdb.data.isadmin">
      <h1>Utenti</h1>
      <v-text-field
        v-model="filtro_utenti"
        label="Filtro"
        placeholder="inserisci qui il nome del cliente"/>
      <v-card
        v-for="(utente,id) in utentif"
        :key="id"
        style="margin:3px">
        <v-card-title><v-icon>mdi-account</v-icon>{{ id }}<v-icon>mdi-arrow-right-circle</v-icon>
          <v-spacer/>
          <v-combobox
            v-model="utente.idcliente"
            :items="clienti"
            dense
            item-text="descrizione"
            item-value="id"
            label="cliente principale"
            @input="setclienteprincipale(utente, id)"
          />
          <v-spacer/>
          <v-combobox
            v-model="utente.lingua"
            :items="['IT','EN']"
            dense
            label="lingua"
            @input="aggiornalinguautente(utente, id)"
          />
          <v-spacer/>
          <v-checkbox
            v-model="utente.isadmin"
            dense
            label="amministratore"
            @input="aggiornalinguautente(utente, id)"
          />
        </v-card-title>
        <v-card-text>

          <v-combobox
            v-model="utente.listaclienti"
            :items="clienti"
            item-text="descrizione"
            item-value="id"
            label="clienti associati"
            multiple
            chips
            @input="mergetags(utente.listaclienti, id)"
          />
        </v-card-text>
      </v-card>
    </div>

    <h1>Clienti ({{ clienti.length }}) <v-btn @click="carica_altri_clienti()" color="primary" >ancora</v-btn></h1>
    <v-card
      v-for="(cliente,id) in clienti"
      :key="id">
      <v-card-title @click="setcurrent(cliente)"><v-icon>mdi-factory</v-icon> <strong>{{ cliente.descrizione }}</strong> ({{ cliente.id }}) / {{ cliente.catarticoli }}</v-card-title>

    </v-card>
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="primary"
    />
  </v-container>

</template>
<script>
export default {
  data: () => ({
    utenti: [],
    filtro_utenti: '',
    loading: false

  }),
  computed: {
    listacli () {
      console.log('listacli:', this.$store.state.user)
      var lc = []
      return lc
    },
    utentif () {
      console.log('ute', Object.values(this.utenti))
      return (!this.filtro_utenti || this.filtro_utenti === '') ? this.utenti : Object.values(this.utenti).filter(x => (x.id.includes(this.filtro_utenti)))
    },
    clienti () {
      if (this.$store.state.userdb.data) {
        if (this.$store.state.userdb.data.isadmin) {
          return Object.values(this.$store.state.clienti.data)
        }
        else {
          return Object.values(this.$store.state.userdb.data.listaclienti)
        }
      }
    }
  },
  mounted () {
    console.log('MOUNTED USERS')
    if (this.$store.state.userdb.data) {
      this.$store.dispatch('utenti/fetchAndAdd').then(x => {
        this.utenti = this.$store.state.utenti.data
        console.log('utenti', this.utenti)
      })
    }

    /*
    this.$store.dispatch('utenti/fetchById', this.$store.state.user.data.email).then(x => {
      if (x.isadmin) {
        this.clienti = Object.values(this.$store.state.clienti.data)
      } else {
        this.clienti = x.listaclienti
      }
      console.log(x)
    }) */
  },
  methods: {
    setcurrent (cliente) {
      // this.$store.commit('setCliente', cliente)
      this.loading = true
      this.$store.dispatch('CARICA_CLIENTE', cliente).then(x => {
        console.log(x)
        this.loading = false
      })
        .catch(err => {
          console.log(err)
          this.loading = false
        })
    },
    mergetags (valori, emailutente) {
      console.log('creo tag', valori, emailutente)
      if (valori) {
        var lista = valori.map(({ id, descrizione }) => ({ id, descrizione }))
        this.$store.dispatch('userdb/setPathVars', { email: emailutente })
          .then(x => {
            this.$store.dispatch('userdb/set', { id: emailutente, listaclienti: lista })
          })
      }
    },
    carica_altri_clienti () {
      this.$store.dispatch('clienti/fetchAndAdd')
        .then(x => {
          console.log('cli>', x)
          if (!x.done) {
            this.carica_altri_clienti()
          }
        })
    },
    setclienteprincipale (utente, emailutente) {
      if (utente) {
        this.$store.dispatch('userdb/setPathVars', { email: emailutente })
          .then(x => {
            this.$store.dispatch('userdb/set', { idcliente: utente.idcliente.id })
            // this.$store.dispatch('labels/SET_LAN', utente.idcliente.lingua)
          })
      }
    },
    aggiornalinguautente (utente, emailutente) {
      if (utente) {
        this.$store.dispatch('userdb/setPathVars', { email: emailutente })
          .then(x => {
            this.$store.dispatch('userdb/set', { lingua: utente.lingua, isadmin: utente.isadmin })
          })
      }
    }
  }
}
</script>
